import { Box, FormControl, FormControlLabel, FormLabel, Grid, IconButton, MenuItem, Modal, Radio, RadioGroup, Select, Typography, Container, Button, Tooltip, Avatar, TextField } from '@mui/material'
import React, { useEffect, useState } from 'react'
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import CloseIcon from '@mui/icons-material/Close';
import CustomButtoncolor from '../custom-button/customColorButton';
import { storeAppointmentNotes } from '../../store/crm/appointment/notes';
import { getAppointmentDetails, getAppointmentcalender } from '../../store/crm/appointment';
import { successConfirmation } from '../../services/utills';
import { getStaff } from '../../store/crm/reports';
import { useDispatch, useSelector } from 'react-redux';
import CustomButton from '../custom-button/customButton';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import Waveloading from '../../pages/loading/Waveloading';
import { useParams } from 'react-router';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import AddAPhotoIcon from '@mui/icons-material/AddAPhoto';
import SaveIcon from '@mui/icons-material/Save';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import AddIcon from '@mui/icons-material/Add';
import { getCrmNotes, storeCrmNotes } from '../../store/crm/crm/crm-details';
import { getAllTags, storeAppointmentAttachment, storeAppointmentGallery, storeTag } from '../../store/crm/appointment/attachment';
import ImageUploader from '../image-uploader/imageUploader';
import CustomModal from './customModal';
import toast from 'react-hot-toast';
import { NOTE_MAX_LENGTH } from '../../utils/noteLimits';
import NoteLimitCounter from "../note-limit/NoteLimitCounter";
const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 500,
    bgcolor: 'background.paper',
     maxWidth: "1200px",
      maxHeight: "90vh",        // <<< FIXED HEIGHT
        overflowY: "auto",        // <<< SCROLL INSIDE
    p: '27px 12px',
          height:"90vh",
       width: {   
        xs: '90%',   // Extra small devices
        sm: '90%',   // Small devices
        md: '80%',   // Medium devices
        lg: '80%',   // Large devices
        xl: '80%',   // Extra large devices
    },
    borderRadius:'15px',
    '@media (max-width: 550px)': {
      width: "95%",
    },
    gap:"5px"
  };
  const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = { 
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 250,
        },
    },
};
const labelStyles ={
    color:'#000',
    fontSize:'16px',
    mb:'10px',
    "&.Mui-focused": { 
        color:'#000!important',
    }
}
 
const AddAttachmentModal = ({appointmentDetails,wid,panelMode,onPanelClose,onCloseAll}) => {
    const [open, setOpen] = useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => { setOpen(false); onPanelClose?.(); };
    const [files,setFiles] = useState([])
    const [loading,setLoading] = useState(false)
    // const [selectedServices,setSelectedServices] = useState({})
    const [tagId,setTagId] = useState({})
    const [comments,setComments] = useState('') 
    const [isMilestone,setIsMilestone] = useState(false)    
    const [tag,setTag] = useState('')
    const [isAddTag,setIsAddTag] = useState(false)

    const dispatch = useDispatch()
    const crmAppointmentAttachmentStore = useSelector(state => state?.crmAppointmentAttachmentStore)
    const {tags=[]}= crmAppointmentAttachmentStore

   //console.log("id",appointmentDetails)
    const handleSubmit = async () => {
      if (files?.length){
      // if (files?.length && selectedServices?.id && comments?.length){

          setLoading(true)
          const formData = new FormData();

          formData.append("booking_id", appointmentDetails?.id);
          // formData.append("service_id", selectedServices?.id);
          if (tagId?.id) {
            formData.append("tag_id", tagId?.id);
          }
          formData.append("comment", comments); 
          formData.append("is_milestone", isMilestone ? "1" :'0');

          files.forEach(value => formData.append("files" + '[]', value))
          let res = await  dispatch(storeAppointmentGallery({data:formData,booking_id:appointmentDetails?.id}))
 
          setLoading(false) 
          if (res?.payload?.success === 'true'){
              // setSelectedServices({})
               dispatch(getAppointmentDetails(appointmentDetails?.id))
               dispatch(getCrmNotes(appointmentDetails?.customer?.id))
              setFiles([])
              setComments('')
              toast.success(`Gallery ${isMilestone ? " and Milestone " :"" }added successfully!`)
              handleClose();
            //   if (setActive){
            //       setActive(1)
            //   } 
          }       
          else{
            // toast.error("All Fields are required",`All Fields are required`,'error')
          }  
      }else {
          toast.error("All Fields are required",`All Fields are required`,'error')
        //   handleClose();

      }
    }

    const handleRemove = (file) => { 
        if (files?.length) {
            let finalData = files.filter((item) => file?.path !== item?.path && file?.size !== item?.size)
            setFiles(finalData)
        }
    }   

    useEffect(()=>{
        (async ()=>{
            if (!tags?.length > 0){       
                await dispatch(getAllTags())
            }
        })()
    },[])

    const handleSave = (item) => {
        let finalData = [...files,...item]
        let uniqueFiles = finalData.filter((file, index, self) =>
            index === self.findIndex((f) => (
                f.name === file.name && f.size === file.size
                ))
        );

        setFiles(uniqueFiles)

    }

    const handleSaveTag = async () => {
      if (tag?.length > 2){
          setLoading(true)

          let res = await  dispatch(storeTag({tag_name:tag}))
          setLoading(false)

          if(res?.payload?.success === 'true'){
             toast.success('SuccessTag added successfully!',"")
              setIsAddTag(false)
              
          }else {
              toast.error('Error',"Tag Already Exist",'error')

          }
      }
    }

  if (panelMode) {
    const fieldLabel = { fontSize: '13px', fontWeight: 700, color: '#1a1a2e', mb: '6px' };
    return (
      <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%', background: '#fff' }}>
        {/* Header */}
        <Box sx={{ display: 'flex', alignItems: 'center', px: 2.5, py: 2, borderBottom: '1px solid #F1F2F6', flexShrink: 0, background: '#fff', gap: 1 }}>
          <IconButton size="small" onClick={onPanelClose} sx={{ color: '#A72C68', '&:hover': { background: '#FAEFF5' } }}>
            <ArrowBackIcon sx={{ fontSize: 18 }} />
          </IconButton>
          <Typography sx={{ flex: 1, fontWeight: 700, fontSize: '16px', fontFamily: 'helvetica-lt-std-bold,sans-serif', color: '#1a1a2e' }}>Add New Gallery</Typography>
          <IconButton size="small" onClick={onCloseAll} sx={{ color: '#9A9797', '&:hover': { color: '#EB5757', background: '#ffeaea' } }}>
            <CloseIcon sx={{ fontSize: 18 }} />
          </IconButton>
        </Box>
        {loading ? (
          <Box sx={{ minHeight: '200px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}><Waveloading /></Box>
        ) : (
          <Box sx={{ flex: 1, overflow: 'auto', p: 2.5 }}>
            {/* Upload zone */}
            <Box sx={{
              border: '1.5px dashed #E5A8C2',
              borderRadius: '12px',
              background: '#FAF8FF',
              p: 2.5,
              display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
              mb: 2,
              transition: 'border-color 0.15s, background 0.15s',
              '&:hover': { borderColor: '#A72C68', background: '#FAEFF5' },
              '& > div': { width: '100%' },
            }}>
              <CloudUploadIcon sx={{ fontSize: 38, color: '#A72C68', mb: 1 }} />
              <Typography sx={{ fontSize: '13px', fontWeight: 600, color: '#1a1a2e', textAlign: 'center' }}>Drop files here or click to upload</Typography>
              <Typography sx={{ fontSize: '11px', color: '#8a8d97', mb: 1.5 }}>JPG, PNG, PDF (Max. 10MB each)</Typography>
              <Box sx={{
                width: '100%',
                '& button, & .MuiButton-root': {
                    background: 'transparent !important', color: '#A72C68', border: 'none', boxShadow: 'none',
                },
              }}>
                <ImageUploader handleSave={handleSave} />
              </Box>
            </Box>

            {/* Selected files preview */}
            {files?.length > 0 && (
              <Box sx={{ display: 'flex', gap: '12px', flexWrap: 'wrap', mb: 2, maxHeight: '220px', overflowY: 'auto' }}>
                {files.map((file, key) => (
                  <Box key={key} sx={{ position: 'relative' }}>
                    <IconButton
                      onClick={() => handleRemove(file)}
                      sx={{ position: 'absolute', top: 4, right: 4, zIndex: 1, background: '#EB5757', p: '4px', '&:hover': { background: '#d32f2f' } }}
                    >
                      <DeleteOutlineIcon sx={{ color: '#fff', fontSize: '14px' }} />
                    </IconButton>
                    <Avatar src={URL.createObjectURL(file)} sx={{ borderRadius: '10px', height: 100, width: 100 }} variant="rounded" />
                  </Box>
                ))}
              </Box>
            )}

            {/* Comments */}
            <Box sx={{ mb: 2 }}>
              <Typography sx={fieldLabel}>Comments</Typography>
              <Box sx={{ position: 'relative', border: '1px solid #ECEDF2', borderRadius: '10px', background: '#fff', transition: 'border-color 0.15s', '&:focus-within': { borderColor: '#A72C68' } }}>
                <textarea
                  rows={4}
                  value={comments}
                  placeholder="Write your comments..."
                  maxLength={NOTE_MAX_LENGTH}
                  onChange={(e) => setComments(e.target.value)}
                  style={{ width: '100%', resize: 'vertical', padding: '10px 12px 22px', border: 'none', outline: 'none', borderRadius: '10px', fontFamily: 'inherit', fontSize: '13px', background: 'transparent', color: '#1a1a2e', boxSizing: 'border-box' }}
                />
                <NoteLimitCounter value={comments} label="Comment" />
              </Box>
            </Box>

            {/* Gallery Tag */}
            <Box sx={{ mb: 2 }}>
              <Typography sx={fieldLabel}>Gallery Tag</Typography>
              <Box sx={{ display: 'flex', gap: 1 }}>
                <Select
                  size="small"
                  fullWidth
                  value={tagId?.id || ''}
                  displayEmpty
                  MenuProps={MenuProps}
                  renderValue={() => tagId?.tag_name
                    ? <Typography sx={{ fontSize: '13px', color: '#1a1a2e', textTransform: 'capitalize' }}>{tagId.tag_name}</Typography>
                    : <Typography sx={{ fontSize: '13px', color: '#9ca3af' }}>Select or create tag</Typography>}
                  sx={{
                    borderRadius: '10px', background: '#fff',
                    '& .MuiOutlinedInput-notchedOutline': { borderColor: '#ECEDF2' },
                    '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: '#E5A8C2' },
                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: '#A72C68' },
                  }}
                >
                  {tags?.length > 0 ? tags.map((service, key) => (
                    <MenuItem key={key} value={service?.id} onClick={() => setTagId(service)} sx={{ fontSize: '13px', textTransform: 'capitalize' }}>{service?.tag_name}</MenuItem>
                  )) : <MenuItem disabled>No tags yet</MenuItem>}
                </Select>
                <Button
                  variant="outlined"
                  startIcon={<AddIcon sx={{ fontSize: '16px !important' }} />}
                  onClick={() => setIsAddTag(true)}
                  sx={{
                    textTransform: 'none', borderRadius: '10px', whiteSpace: 'nowrap',
                    color: '#A72C68', borderColor: '#F0CDDB', background: '#FDF8FB',
                    fontWeight: 600, fontSize: '12px',
                    '&:hover': { background: '#F4DDE8', borderColor: '#E5A8C2' },
                  }}
                >
                  Add Tag
                </Button>
              </Box>
            </Box>

            {/* Save Gallery */}
            <Button
              fullWidth
              variant="contained"
              startIcon={<SaveIcon sx={{ fontSize: '16px !important' }} />}
              onClick={handleSubmit}
              sx={{
                background: '#27AE60', color: '#fff',
                border: '1px solid #27AE60',
                textTransform: 'none', borderRadius: '10px', py: 1.25,
                fontWeight: 700, fontSize: '14px',
                boxShadow: 'none',
                '&:hover': { background: '#219653', color: '#fff', border: '1px solid #27AE60', boxShadow: 'none' },
              }}
            >
              Save Gallery
            </Button>

            <CustomModal customWidth="500px" setOpen={() => setIsAddTag(false)} open={isAddTag}>
              <Box>
                <Typography sx={{ fontSize: '18px', fontFamily: 'helvetica-lt-std-bold', textAlign: 'center', mb: 2 }}>Add New Tag</Typography>
                <FormControl fullWidth>
                  <FormLabel sx={{ ...labelStyles }}>Tag</FormLabel>
                  <TextField size="small" variant="outlined" value={tag} onChange={(e) => setTag(e.target.value)} />
                </FormControl>
                <Box sx={{ display: 'flex', justifyContent: 'center', mt: '24px' }}>
                  <Button
                    variant="contained"
                    onClick={handleSaveTag}
                    sx={{ background: '#27AE60', color: '#fff', border: '1px solid #27AE60', boxShadow: 'none', textTransform: 'none', borderRadius: '10px', px: 4, '&:hover': { background: '#219653', color: '#fff', border: '1px solid #27AE60', boxShadow: 'none' } }}
                  >
                    Save
                  </Button>
                </Box>
              </Box>
            </CustomModal>
          </Box>
        )}
      </Box>
    );
  }

  return (

<>

{/* <CustomButtoncolor
    handleClick={handleOpen}
     mainColor={"#09ABF1"}
     size="md"
     val='Add Notes'
     style={{
      padding:'7px 5px',
      fontSize: "18px",
      minWidth:'max-content',
      borderRadius: "6px!important",
      width: "100%",
      "@media (minWidth: 420px)": {
          width: 'auto'
      },
  }}                                  
  /> */}
<Box sx={{  textAlign:'center' }}>

<Button variant="contained"
sx={{ backgroundColor:'#09ABF1', color:'#fff',px:4,width:{sm:'auto', xs:wid}, }}
onClick={handleOpen}
> <AddAPhotoIcon sx={{mr:1}}/>
Add A Photo
  
</Button>
</Box>

 
    <Modal
 
     style={{}}
       open={open}
       onClose={handleClose}
       aria-labelledby="modal-modal-title"
       aria-describedby="modal-modal-description"
     >
        <Container maxWidth="xl">
        {/* {loading ? <Waveloading fullSize/>:''} */}
        <Box sx={style}>     
       
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', }}>
                    <IconButton   
                            size="small"
                            onClick={() => setOpen(false)}    
                            style={{ color: "red" }} 
                        > 
                           
                            <CloseRoundedIcon  style={{fontSize: '2rem' }} /> 
                        </IconButton>
                    </Box>
                    <Box sx={{background:"#fff",minHeight:'300px',borderRadius:'8px',p:'24px'}}>
            <Typography sx={{fontSize:'20px'}}>Add New Gallery</Typography>
            {loading? <Waveloading fullSize/>:''}
            <Box sx={{display:'flex',gap:"20px",flexWrap:'wrap',my:'24px',  maxHeight: "250px", overflowY:'scroll'}}> 
                {files?.length > 0 && files.map((file,key)=>(
                    <Box key={key}>
                        <IconButton
                            sx={{  
                                fontSize: "15px", 
                                position: "relative",
                                p:"5px", 
                                zIndex:'1',
                                background:"#EB5757!important",
                                m:'5px',
                                right:'-111px' 
                            }}
                            onClick={() => handleRemove(file) 
                        }
                        >
                            <DeleteOutlineIcon sx={{color:'#fff',fontSize:'16px'}}/>
                        </IconButton>
                        <Avatar
                            src={URL.createObjectURL(file)}
                            sx={{
                                borderRadius:'8px' ,
                                height:'149px',
                                width:'149px',
                                mt:'-36px'
                            }}
                        />
                    </Box>
                ))}
                <ImageUploader handleSave={handleSave} />
            </Box>
            <Grid
                container
                spacing={3}
                sx={{
                    flexDirection:'column',
                }}
            >
                {/*<Grid item xs={12} xl={6}>*/}
                {/*    <FormControl fullWidth>*/}
                {/*        <FormLabel sx={{...labelStyles}}>Service Name</FormLabel>*/}
                {/*        <Select*/}
                {/*            size={'small'}*/}
                {/*            value={selectedServices?.id || ''}*/}
                {/*            displayEmpty*/}
                {/*            MenuProps={MenuProps}*/}
                {/*        >*/}
                {/*            {appointmentDetails?.services?.length > 0 &&appointmentDetails?.services.map((service,key) => (*/}
                {/*                <MenuItem*/}
                {/*                    key={key}*/}
                {/*                    value={service?.id}*/}
                {/*                    onClick={()=>setSelectedServices(service)}*/}
                {/*                >*/}
                {/*                    {service?.name}*/}
                {/*                </MenuItem>*/}
                {/*            ))}*/}
                {/*        </Select>*/}
                {/*    </FormControl>*/}
                {/*</Grid>*/}
                <Grid item xs={12} md={6}>
                    <FormControl fullWidth>
                        <FormLabel sx={{...labelStyles}}>Comments</FormLabel>
                        <textarea
                                className="MuiInputBase-input MuiOutlinedInput-input"
                                rows={3}
                                placeholder={""}
                                value={comments}
                                onChange={(e)=>setComments(e.target.value)}
                                style={{
                                    width: '100%',
                                    resize: 'vertical',
                                    padding: '8px',
                                    border: '1px solid rgba(0, 0, 0, 0.23)',
                                    borderRadius: '4px',
                                    fontFamily: 'inherit',
                                    fontSize: '1rem',
                                }}
                            />
                        {/* <TextField
                            size={'small'}
                            variant="outlined"
                            placeholder={""}
                            value={comments}
                            onChange={(e)=>setComments(e.target.value)}
                        /> */}
                    </FormControl>
                </Grid>
                <Grid
                    xs={12}
                    md={6}
                    item
                    sx={{
                        display:
                            "flex",
                        JustifyContent:'space-between',
                    }}
                >
                    <FormControl fullWidth sx={{maxWidth:'50%',alignItems:'centers'}}>
                        <FormLabel sx={{...labelStyles}}>Gallery Tag</FormLabel>
                        <Select
                            size={'small'}
                            value={tagId?.id || ''}
                            displayEmpty
                            MenuProps={MenuProps}
                        >
                            {tags?.length > 0 ?
                                tags?.map((service,key) => (
                                <MenuItem
                                    key={key}

                                    value={service?.id}
                                    onClick={()=>setTagId(service)}
                                >
                                    {service?.tag_name}
             .
                                </MenuItem>
                            ))
                                : <MenuItem>
                                    Add Tag
                                </MenuItem>
                            }
                        </Select>
                    </FormControl>
                   <Box
                       sx={{
                           width:'50%',
                           display:"flex",
                           alignItems:'flex-end',
                           justifyContent:'flex-end'

                       }}

                   >
                       <CustomButton
                           val={"Add Tag"}
                           handleClick={()=>setIsAddTag(true)}
                       />
                   </Box>
                </Grid>
                {/* <Grid xs={12} item>
                    <FormControlLabel
                        control={
                        <Checkbox
                            checked={isMilestone}
                            onChange={e => {
                                setIsMilestone(e?.target?.checked)
                            }}
                        />
                    }
                        label={"Add Into Milestone"}
                    />
                </Grid> */}
                <Grid xs={12} item>
                    <CustomButton val={'Save'} handleClick={handleSubmit}/>
                </Grid>
            </Grid>
            <CustomModal
                customWidth={'500px'}
                setOpen={() => setIsAddTag(false)} 
                open={isAddTag}
            >
                <Box>
                    <Typography
                        sx={{
                            fontSize:'18px',
                            fontFamily: 'helvetica-lt-std-bold',
                            textAlign:"center",
                        }}
                    >
                        Add New Tag
                    </Typography>

                    <FormControl fullWidth>
                        <FormLabel sx={{...labelStyles}}>Tag</FormLabel>
                        <TextField
                            size={'small'}
                            variant="outlined"
                            placeholder={""}
                            value={tag}
                            onChange={(e)=>setTag(e.target.value)}
                        />
                    </FormControl>

                    <Box
                        sx={{
                            display:'flex',
                            justifyContent:'center',
                            mt:'24px',
                        }}
                    >
                        <CustomButton
                            val={'Save'}
                            size={'large'}
                            handleClick={handleSaveTag}
                        />
                    </Box>
                </Box>
            </CustomModal>
        </Box>
        </Box>
        </Container>
       

     </Modal>
     </>
  )
}

export default AddAttachmentModal